import React from "react"
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react"
import TOS from "@/components/TOS"
import { useNavigate } from "react-router-dom"

export default function TOSView() {
  const navigate = useNavigate()

  return (
    <Modal
      isOpen={true}
      onClose={() => navigate(-1)}
      variant="standard"
      size="xl"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Terms of Service</ModalHeader>
        <ModalCloseButton onClick={() => navigate(-1)} />
        <ModalBody overflow="auto" pb={6}>
          <TOS />
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}
